import { ComponentRenderHooks } from "@launchos/plugins/types";
import * as React from "react";

import DangerousHTML from 'react-dangerous-html';

import { ComponentTypes } from "../../types";
import { PluginProps } from "./types";

export const HTMLPlugin: React.FC<PluginProps> = ({ settings }) => {
  const { html = "" } = settings;
  return (
    <div
      data-testid="WC-HTML-LIVE"
    // dangerouslySetInnerHTML={{ __html: html }}
    >
      <DangerousHTML html={html} />
    </div>
  );
};

export const onComponentRender = (hook, payload, actions) => {
  if (
    hook.id === ComponentRenderHooks.WEBCOMPONENT &&
    payload.type === ComponentTypes.HTML
  ) {
    return [HTMLPlugin];
  }
};

export default HTMLPlugin;
